module.exports = __webpack_public_path__ + "img/tag.91cc25a0.svg";